import * as React from 'react'
import { BasePage } from 'app/shared/components/base/BasePage'
import { Button } from 'primereact/button'
import { RadioButton } from 'primereact/radiobutton'
import { Checkbox } from 'primereact/checkbox'
import Icon from 'app/shared/components/Icon'
import Steps from 'app/shared/components/Steps'
import Tooltip from 'app/shared/components/Tooltip'
import useBasePage from 'app/shared/hooks/base-page.hook'
import {
    useLazySelectCacheInfoQuery,
    useLazySelectComBrnc0102Query,
} from 'app/core/services/com/com.service'
import { WtcnsUrlAdr } from 'app/shared/hooks/util/commonCode.hook'
import { showAlert } from 'app/shared/utils/util'
import InputField from 'app/shared/components/InputField'

/*======================================================================
 * @ 업무설명 : 비밀번호 임시페이지
 * @ 파 일 명 : /app/pages/mai/app/MAIAPP0103.tsx
 * @ 관련API  :
 *======================================================================
 * 번호  작업자           작업일         변경내용
 *======================================================================
 * 1     신재호(S24999)   2025.06.11    최초작성
 *======================================================================
 */

const MAIAPP0103: React.FC = () => {
    const router = useBasePage()
    const [input1, setInput1] = React.useState('')
    const [input2, setInput2] = React.useState('')
    const [fetch0102] = useLazySelectCacheInfoQuery()

    /********************************************************
     * 다음버튼 클릭
     ********************************************************/
    const onButtonClick = async () => {
        const result0102 = await fetch0102({
            dsrnTgtBacd: '110',
            ccddId: '',
            cdgpId: 'TMP_PW_CHK',
        })

        const data = result0102.data.data[0] as unknown as WtcnsUrlAdr

        if (data.cdAtrbEtc2Con === input1 && data.cdAtrbEtc3Con === input2) {
            window.sessionStorage.setItem('isLogined', 'true')
            window.location.reload()
        } else {
            showAlert({
                msg: '비밀번호가 일치하지 않습니다.',
            })
        }
    }

    return (
        <BasePage
            title="로그인"
            prev={false}
            // onPrev={router.goBack}
            footerPosition="fixed"
            footerContent={
                <div className="buttons-x">
                    {/* disabled 버전 추가 */}
                    <Button
                        label="확인"
                        className="button-basic-primary -lg"
                        onClick={onButtonClick}
                    />
                </div>
            }
            className="pt-0"
        >
            <div className="password-box mt-16">
                <h2 className="h4">비밀번호를 입력해주세요</h2>

                <div className="input-basic mt-40">
                    <p className="password-txt">비밀번호 1</p>
                    <InputField
                        type={'password'}
                        placeholder="비밀번호"
                        value={input1}
                        onChange={(e) => setInput1(e.target.value)}
                        onClear={() => setInput1('')}
                    />
                </div>
                <div className="input-basic mt-24">
                    <p className="password-txt">비밀번호 2</p>
                    <InputField
                        type={'password'}
                        placeholder="비밀번호"
                        value={input2}
                        onChange={(e) => setInput2(e.target.value)}
                        onClear={() => setInput2('')}
                    />
                </div>
            </div>
        </BasePage>
    )
}

export default MAIAPP0103
